/** Support surface shell (S-02 / S-03). Shared inbox + request analytics. */

import { BellIcon, GearIcon, RoleLayout, UserIcon } from "../../components/RoleLayout";

export function SupportLayout() {
  return (
    <RoleLayout
      title="Support"
      nav={[
        // A notification's ticket link (/tickets/:id) opens in the inbox (RESP-04).
        { to: "/staff/support/inbox", label: "Inbox", short: "Inbox", icon: <BellIcon />, also: ["/staff/support/tickets"] },
        { to: "/staff/support/analytics", label: "Analytics", short: "Stats", icon: <GearIcon /> },
        { to: "/staff/support/profile", label: "Profile", short: "Profile", icon: <UserIcon /> },
      ]}
    />
  );
}
